<script setup lang="ts">
import { useTranslation } from '@hfc/ui-core';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

defineProps<{
  carrierId?: string;
  forceSmallWidth?: boolean;
}>();

const { getBaseUrl, getCdnUrl } = useUrlHelper();
const { t } = useTranslation();
</script>

<template>
  <div v-if="!carrierId" class="flex justify-start">
    <span class="sr-only">{{ t('common.branding') }}</span>
    <a :href="getBaseUrl('/')" class="min-w-[47px] lg:min-w-[60px]" :class="{ 'max-2xs:min-w-[43px]': forceSmallWidth }" tabindex="0">
      <img :src="getCdnUrl('/assets/img/logos/hfc_stack.png')"
        class="h-12 md:h-10 lg:h-16 pr-2 focus-visible:outline-none dark:fill-white"
        :class="{ 'max-2xs:pr-1': forceSmallWidth }"
        :alt="t('common.branding')">
    </a>
    <img :src="getCdnUrl('/assets/img/logos/cov_cal.png')"
      class="h-12 md:h-10 lg:h-16 pl-2 border-l border-blue-200 focus-visible:outline-none dark:fill-white"
      :class="{ 'max-2xs:pl-1': forceSmallWidth }"
      :alt="t('common.coveredCalifornia')">
  </div>
  <carrier-logo v-else :carrier-id="carrierId" :no-link="true" :vertical="true"
    class="w-28 md:w-36 pr-2 pl-2 focus-visible:outline-none dark:fill-white h-12 md:h-10 lg:h-16 flex items-center"
    :class="{ 'max-2xs:pr-1 max-2xs:pl-1': forceSmallWidth }" />
</template>
